module.exports = __webpack_public_path__ + "static/media/tvnz.86be5fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AsSeenOnTV/brands/tvnz.png
// module id = 578
// module chunks = 0